import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import RouteGate from './RouteGate';

/**
 * Authentication, then page gating.
 *
 * RBAC Phase 3 added the second half: `RouteGate` applies the navigation
 * registry to the URL, so hiding a page from the menu also refuses it when
 * typed or bookmarked. Wrapping here rather than at each of the ~870 route
 * declarations means a new route cannot skip the gate by forgetting a wrapper.
 * The gate degrades to "allow" whenever the registry is unavailable,
 * unconfigured or switched off — see `useRouteGate`.
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, token, user } = useSelector((state) => state.auth);

  // Simple authentication check - just check if we have a token
  const hasToken = localStorage.getItem('token') || token;

  if (hasToken || isAuthenticated) {
    // Check if user must change their password before accessing any protected page
    const storedUser = user || JSON.parse(localStorage.getItem('user'));
    if (storedUser?.must_change_password) {
      return <Navigate to="/auth/change-password" replace />;
    }
    return <RouteGate>{children}</RouteGate>;
  }

  // Redirect to login if no token found
  return <Navigate to="/auth/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;
